import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Content from 'Settings/Content';
import SaveIcon from '@material-ui/icons/Save';
import Button from '@material-ui/core/Button';
import { getService } from 'reducers/service';
import { handleError } from 'reducers/ErrorReducer';
import { notify } from 'reducers/NotifierReducer';
import Autocomplete2 from 'components/Autocomplete2';
import { gridStyle, Row, RowInner, ColCard, Fills } from 'utils/formStyles';
import TextField2 from 'components/TextField2';
import Checkbox2 from 'components/Checkbox2';

const useStyles = makeStyles(theme => ({
  item: {
    ...gridStyle(200, 800),
  },
  flexItem: {
    flex: '1 1 33%',
  },
}));

function MobileApp(props) {
  const { States } = props.dictionary;
  const classes = useStyles();
  const service = getService('settings-mobile');
  const [defaultState, setDefaultState] = useState(null);
  const [idle, setIdle] = useState('');
  const [xgridKey, setXgridKey] = useState('');
  const [mobPassValidate, setMobPassValidate] = useState(false);
  const [eslintNoDevError, setEslintNoDevError] = useState(false);
  const [savePass, setSavePass] = useState(false);
  const [featuresCitations, setFeaturesCitations] = useState(false);
  const [avl, setAvl] = useState(false);
  const [yearRequired, setYearRequired] = useState(false);
  const [disableEslint, setDisableEslint] = useState(false);

  const [ncicDefaultState, setNcicDefaultState] = useState(null);
  const [ncicIdle, setNcicIdle] = useState('');
  const [ncicXgridKey, setNcicXgridKey] = useState('');
  const [ncicSearchType, setNcicSearchType] = useState('');
  const [ncicPassValidate, setNcicPassValidate] = useState(false);
  const [ncicEslintNoDevError, setNcicEslintNoDevError] = useState(false);
  const [ncicSavePass, setNcicSavePass] = useState(false);
  const [ncicYearRequired, setNcicYearRequired] = useState(false);
  const [ncicDisableEslint, setNcicDisableEslint] = useState(false);
  const [ncicLocalSearch, setNcicLocalSearch] = useState(false);

  useEffect(() => {
    search();
  }, [States]);

  const search = async () => {
    const data = await service.find({
      query: { type: 'mobile' },
    });
    setInitialData(data);
    const ncicData = await service.find({
      query: { type: 'ncic' },
    });
    setNcicInitialData(ncicData);
  };

  const setInitialData = data => {
    for (const row of data) {
      switch (row.CDRKey) {
        case 'APP_DEFAULT_STATE':
          const state = States?.find(s => s.Code === row.ValueString) || null;
          setDefaultState(state);
          break;
        case 'APP_IDLE_TIMEOUT':
          setIdle(row.ValueString || '');
          break;
        case 'APP_XGRID_KEY':
          setXgridKey(row.ValueString || '');
          break;
        case 'AVL':
          setAvl(row.ValueBoolean);
          break;
        case 'DISABLE_ESLINT':
          setDisableEslint(row.ValueBoolean);
          break;
        case 'ESLINT_NO_DEV_ERRORS':
          setEslintNoDevError(row.ValueBoolean);
          break;
        case 'FEATURES_CITATIONS':
          setFeaturesCitations(row.ValueBoolean);
          break;
        case 'NCIC_PASS_VALIDATE':
          setMobPassValidate(row.ValueBoolean);
          break;
        case 'SAVE_PASS':
          setSavePass(row.ValueBoolean);
          break;
        case 'YEAR_REQUIRED':
          setYearRequired(row.ValueBoolean);
          break;
      }
    }
  };

  const setNcicInitialData = data => {
    for (const row of data) {
      switch (row.CDRKey) {
        case 'APP_DEFAULT_STATE':
          const state = States?.find(s => s.Code === row.ValueString) || null;
          setNcicDefaultState(state);
          break;
        case 'APP_IDLE_TIMEOUT':
          setNcicIdle(row.ValueString || '');
          break;
        case 'APP_XGRID_KEY':
          setNcicXgridKey(row.ValueString || '');
          break;
        case 'APP_SEARCH_TYPE':
          setNcicSearchType(row.ValueString || '');
          break;
        case 'DISABLE_ESLINT':
          setNcicDisableEslint(row.ValueBoolean);
          break;
        case 'ESLINT_NO_DEV_ERRORS':
          setNcicEslintNoDevError(row.ValueBoolean);
          break;
        case 'LOCAL_SEARCH':
          setNcicLocalSearch(row.ValueBoolean);
          break;
        case 'NCIC_PASS_VALIDATE':
          setNcicPassValidate(row.ValueBoolean);
          break;
        case 'SAVE_PASS':
          setNcicSavePass(row.ValueBoolean);
          break;
        case 'YEAR_REQUIRED':
          setNcicYearRequired(row.ValueBoolean);
          break;
      }
    }
  };

  const formatSaveData = () => {
    return [
      {
        CDRKey: 'APP_DEFAULT_STATE',
        ValueString: defaultState?.Code || null,
        ValueBoolean: null,
      },
      {
        CDRKey: 'APP_IDLE_TIMEOUT',
        ValueString: idle || null,
        ValueBoolean: null,
      },
      {
        CDRKey: 'APP_XGRID_KEY',
        ValueString: xgridKey || null,
        ValueBoolean: null,
      },
      {
        CDRKey: 'AVL',
        ValueString: null,
        ValueBoolean: avl,
      },
      {
        CDRKey: 'DISABLE_ESLINT',
        ValueString: null,
        ValueBoolean: disableEslint,
      },
      {
        CDRKey: 'ESLINT_NO_DEV_ERRORS',
        ValueString: null,
        ValueBoolean: eslintNoDevError,
      },
      {
        CDRKey: 'FEATURES_CITATIONS',
        ValueString: null,
        ValueBoolean: featuresCitations,
      },
      {
        CDRKey: 'NCIC_PASS_VALIDATE',
        ValueString: null,
        ValueBoolean: mobPassValidate,
      },
      {
        CDRKey: 'SAVE_PASS',
        ValueString: null,
        ValueBoolean: savePass,
      },
      {
        CDRKey: 'YEAR_REQUIRED',
        ValueString: null,
        ValueBoolean: yearRequired,
      },
    ];
  };

  const formatNcicSaveData = () => {
    return [
      {
        CDRKey: 'APP_DEFAULT_STATE',
        ValueString: ncicDefaultState?.Code || null,
        ValueBoolean: null,
      },
      {
        CDRKey: 'APP_IDLE_TIMEOUT',
        ValueString: ncicIdle || null,
        ValueBoolean: null,
      },
      {
        CDRKey: 'APP_XGRID_KEY',
        ValueString: ncicXgridKey || null,
        ValueBoolean: null,
      },
      {
        CDRKey: 'APP_SEARCH_TYPE',
        ValueString: ncicSearchType || null,
        ValueBoolean: null,
      },
      {
        CDRKey: 'DISABLE_ESLINT',
        ValueString: null,
        ValueBoolean: ncicDisableEslint,
      },
      {
        CDRKey: 'ESLINT_NO_DEV_ERRORS',
        ValueString: null,
        ValueBoolean: ncicEslintNoDevError,
      },
      {
        CDRKey: 'LOCAL_SEARCH',
        ValueString: null,
        ValueBoolean: ncicLocalSearch,
      },
      {
        CDRKey: 'NCIC_PASS_VALIDATE',
        ValueString: null,
        ValueBoolean: ncicPassValidate,
      },
      {
        CDRKey: 'SAVE_PASS',
        ValueString: null,
        ValueBoolean: ncicSavePass,
      },
      {
        CDRKey: 'YEAR_REQUIRED',
        ValueString: null,
        ValueBoolean: ncicYearRequired,
      },
    ];
  };

  const handleSaveClick = async () => {
    const data = formatSaveData();
    const ncicData = formatNcicSaveData();
    try {
      await service.create({ dataArr: data, type: 'mobile' });
      await service.create({ dataArr: ncicData, type: 'ncic' });
      props.notify('Settings Saved.', 'success');
    } catch (err) {
      props.handleError(err, 'Error Saving Settings.');
    }
  };

  const renderDefaultState = () => {
    return (
      <div>
        <Autocomplete2
          options={States}
          className={classes.item}
          onChange={(ev, val) => setDefaultState(val)}
          value={defaultState}
          label="Default State"
        />
      </div>
    );
  };

  const renderIdleTimeout = () => {
    const onChange = (ev, val) => setIdle(val);
    return (
      <TextField2 className={classes.item} label="Idle Timeout" value={idle} onChange={onChange} />
    );
  };

  const renderXgridKey = () => {
    const onChange = (ev, val) => setXgridKey(val);
    return (
      <TextField2 className={classes.item} label="Xgrid Key" value={xgridKey} onChange={onChange} />
    );
  };

  const renderMobPassValidate = () => {
    return (
      <Checkbox2
        checked={mobPassValidate}
        onChange={() => setMobPassValidate(!mobPassValidate)}
        label="NCIC Pass Validate"
        tooltipText="Enable NCIC password validation. Passwords must include uppercase, number, and special character."
      />
    );
  };
  const renderEslintNoDevError = () => {
    return (
      <Checkbox2
        checked={eslintNoDevError}
        onChange={() => setEslintNoDevError(!eslintNoDevError)}
        label="Eslint No Dev Errors"
        tooltipText="Suppresses ESLint errors during development. This allows the app to run without blocking builds on linting issues."
      />
    );
  };
  const renderSavePass = () => {
    return (
      <Checkbox2
        checked={savePass}
        onChange={() => setSavePass(!savePass)}
        label="Save Pass"
        tooltipText="Allow the browser to remember and auto-fill your login credentials."
      />
    );
  };
  const renderFeaturesCitations = () => {
    return (
      <Checkbox2
        checked={featuresCitations}
        onChange={() => setFeaturesCitations(!featuresCitations)}
        label="Features Citations"
        tooltipText="Enable or disable the eCitation module. Disabling removes it from the main navigation."
      />
    );
  };
  const renderAvl = () => {
    return (
      <Checkbox2
        checked={avl}
        onChange={() => setAvl(!avl)}
        label="AVL"
        tooltipText="Enable AVL (Automatic Vehicle Location) to request location permission and track location in real time."
      />
    );
  };
  const renderYearRequired = () => {
    return (
      <Checkbox2
        checked={yearRequired}
        onChange={() => setYearRequired(!yearRequired)}
        label="Year Required"
        tooltipText="Require users to enter the license plate year when performing LPN lookups."
      />
    );
  };
  const renderDisableEslint = () => {
    return (
      <Checkbox2
        checked={disableEslint}
        onChange={() => setDisableEslint(!disableEslint)}
        label="Disable Eslint"
        tooltipText="ESLint is a tool that analyzes code for errors, bugs, and bad practices. Disabling this will turn off code linting/validation."
      />
    );
  };

  const renderNcicDefaultState = () => {
    return (
      <div>
        <Autocomplete2
          options={States}
          className={classes.item}
          onChange={(ev, val) => setNcicDefaultState(val)}
          value={ncicDefaultState}
          label="Default State"
        />
      </div>
    );
  };
  const renderNcicIdleTimeout = () => {
    const onChange = (ev, val) => setNcicIdle(val);
    return (
      <TextField2
        className={classes.item}
        label="Idle Timeout"
        value={ncicIdle}
        onChange={onChange}
      />
    );
  };
  const renderNcicXgridKey = () => {
    const onChange = (ev, val) => setNcicXgridKey(val);
    return (
      <TextField2
        className={classes.item}
        label="Xgrid Key"
        value={ncicXgridKey}
        onChange={onChange}
      />
    );
  };
  const renderNcicSearchType = () => {
    const onChange = (ev, val) => setNcicSearchType(val);
    return (
      <TextField2
        className={classes.item}
        label="Search Type"
        value={ncicSearchType}
        onChange={onChange}
      />
    );
  };
  const renderNcicPassValidate = () => {
    return (
      <Checkbox2
        checked={ncicPassValidate}
        onChange={() => setNcicPassValidate(!ncicPassValidate)}
        label="NCIC Pass Validate"
        tooltipText="Enable NCIC password validation. Passwords must include uppercase, number, and special character."
      />
    );
  };
  const renderNcicEslintNoDevError = () => {
    return (
      <Checkbox2
        checked={ncicEslintNoDevError}
        onChange={() => setNcicEslintNoDevError(!ncicEslintNoDevError)}
        label="Eslint No Dev Errors"
        tooltipText="Suppresses ESLint errors during development. This allows the app to run without blocking builds on linting issues."
      />
    );
  };
  const renderNcicSavePass = () => {
    return (
      <Checkbox2
        checked={ncicSavePass}
        onChange={() => setNcicSavePass(!ncicSavePass)}
        label="Save Pass"
        tooltipText="Allow the browser to remember and auto-fill your login credentials."
      />
    );
  };
  const renderNcicYearRequired = () => {
    return (
      <Checkbox2
        checked={ncicYearRequired}
        onChange={() => setNcicYearRequired(!ncicYearRequired)}
        label="Year Required"
        tooltipText="Require users to enter the license plate year when performing LPN lookups."
      />
    );
  };
  const renderNcicDisableEslint = () => {
    return (
      <Checkbox2
        checked={ncicDisableEslint}
        onChange={() => setNcicDisableEslint(!ncicDisableEslint)}
        label="Disable Eslint"
        tooltipText="ESLint is a tool that analyzes code for errors, bugs, and bad practices. Disabling this will turn off code linting/validation."
      />
    );
  };
  const renderNcicLocalSearch = () => {
    return (
      <Checkbox2
        checked={ncicLocalSearch}
        onChange={() => setNcicLocalSearch(!ncicLocalSearch)}
        label="Local Search"
        tooltipText="Enable to use local search. If disabled the search will use NCIC."
      />
    );
  };

  const renderSaveBtn = () => {
    return (
      <div className="text-right pb-3">
        <Button onClick={handleSaveClick} variant="contained" color="primary">
          <SaveIcon className="mr-2" /> Save
        </Button>
      </div>
    );
  };

  return (
    <Content>
      <div className="m-5">
        <h3>Mobile App Default Values</h3>
        {renderSaveBtn()}
        <Row>
          <ColCard minWidth={500}>
            {renderDefaultState()}
            <RowInner>{renderIdleTimeout()}</RowInner>
            <RowInner>{renderXgridKey()}</RowInner>
          </ColCard>
          <ColCard minWidth={500}>
            <RowInner style={{ display: 'flex', flexWrap: 'wrap' }}>
              <div className={classes.flexItem}>{renderMobPassValidate()}</div>
              <div className={classes.flexItem}>{renderSavePass()}</div>
              <div className={classes.flexItem}>{renderYearRequired()}</div>
              <div className={classes.flexItem}>{renderFeaturesCitations()}</div>
              <div className={classes.flexItem}>{renderAvl()}</div>
              <div className={classes.flexItem}>{renderEslintNoDevError()}</div>
              <div className={classes.flexItem}>{renderDisableEslint()}</div>
              <div className={classes.flexItem}>
                <Fills className={classes.item} />
              </div>
            </RowInner>
          </ColCard>
        </Row>
      </div>

      <hr className="mx-5" />

      <div className="m-5">
        <h3>NCIC App Default Values</h3>
        <Row className="mt-5">
          <ColCard minWidth={500}>
            {renderNcicDefaultState()}
            <RowInner>
              {renderNcicIdleTimeout()}
              {renderNcicSearchType()}
            </RowInner>
            <RowInner>{renderNcicXgridKey()}</RowInner>
          </ColCard>
          <ColCard minWidth={500}>
            <RowInner style={{ display: 'flex', flexWrap: 'wrap' }}>
              <div className={classes.flexItem}>{renderNcicPassValidate()}</div>
              <div className={classes.flexItem}>{renderNcicSavePass()}</div>
              <div className={classes.flexItem}>{renderNcicYearRequired()}</div>
              <div className={classes.flexItem}>{renderNcicLocalSearch()}</div>
              <div className={classes.flexItem}>{renderNcicEslintNoDevError()}</div>
              <div className={classes.flexItem}>{renderNcicDisableEslint()}</div>
              <Fills className={classes.item} />
            </RowInner>
          </ColCard>
        </Row>
      </div>
    </Content>
  );
}

const mapStateToProps = state => {
  return {
    dictionary: state.dictionary,
  };
};

export default connect(mapStateToProps, {
  handleError,
  notify,
})(MobileApp);
